import { render, staticRenderFns } from "./PatientSection.vue?vue&type=template&id=088f0fbc&"
import script from "./PatientSection.vue?vue&type=script&lang=js&"
export * from "./PatientSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports